export const LIST_INTEGRATION_API_REQUEST = 'LIST_INTEGRATION_API_REQUEST'
export const LIST_INTEGRATION_API_SUCCESS = 'LIST_INTEGRATION_API_SUCCESS'
export const LIST_INTEGRATION_API_FAIL = 'LIST_INTEGRATION_API_FAIL'

export const LIST_SYNC_LOG_REQUEST = 'LIST_SYNC_LOG_REQUEST'
export const LIST_SYNC_LOG_SUCCESS = 'LIST_SYNC_LOG_SUCCESS'
export const LIST_SYNC_LOG_FAIL = 'LIST_SYNC_LOG_FAIL'

export const LIST_INTEGRATION_API_SUMMARY_REQUEST =
  'LIST_INTEGRATION_API_SUMMARY_REQUEST'
export const LIST_INTEGRATION_API_SUMMARY_SUCCESS =
  'LIST_INTEGRATION_API_SUMMARY_SUCCESS'
export const LIST_INTEGRATION_API_SUMMARY_FAIL =
  'LIST_INTEGRATION_API_SUMMARY_FAIL'

export const CREATE_INTEGRATION_API_REQUEST = 'CREATE_INTEGRATION_API_REQUEST'
export const CREATE_INTEGRATION_API_SUCCESS = 'CREATE_INTEGRATION_API_SUCCESS'
export const CREATE_INTEGRATION_API_FAIL = 'CREATE_INTEGRATION_API_FAIL'

export const DETAIL_INTEGRATION_API_REQUEST = 'DETAIL_INTEGRATION_API_REQUEST'
export const DETAIL_INTEGRATION_API_SUCCESS = 'DETAIL_INTEGRATION_API_SUCCESS'
export const DETAIL_INTEGRATION_API_FAIL = 'DETAIL_INTEGRATION_API_FAIL'

export const UPDATE_INTEGRATION_API_REQUEST = 'UPDATE_INTEGRATION_API_REQUEST'
export const UPDATE_INTEGRATION_API_SUCCESS = 'UPDATE_INTEGRATION_API_SUCCESS'
export const UPDATE_INTEGRATION_API_FAIL = 'UPDATE_INTEGRATION_API_FAIL'

export const DELETE_INTEGRATION_API_REQUEST = 'DELETE_INTEGRATION_API_REQUEST'
export const DELETE_INTEGRATION_API_SUCCESS = 'DELETE_INTEGRATION_API_SUCCESS'
export const DELETE_INTEGRATION_API_FAIL = 'DELETE_INTEGRATION_API_FAIL'

export const REGENERATE_INTEGRATION_API_REQUEST =
  'REGENERATE_INTEGRATION_API_REQUEST'
export const REGENERATE_INTEGRATION_API_SUCCESS =
  'REGENERATE_INTEGRATION_API_SUCCESS'
export const REGENERATE_INTEGRATION_API_FAIL = 'REGENERATE_INTEGRATION_API_FAIL'

export const RESET_INTEGRATION_API = 'RESET_INTEGRATION_API'

export const LIST_MAPPING_INTEGRATION_REQUEST = 'LIST_MAPPING_INTEGRATION_REQUEST'
export const LIST_MAPPING_INTEGRATION_SUCCESS = 'LIST_MAPPING_INTEGRATION_SUCCESS'
export const LIST_MAPPING_INTEGRATION_FAIL = 'LIST_MAPPING_INTEGRATION_FAIL'

export const CREATE_MAPPING_INTEGRATION_REQUEST = 'CREATE_MAPPING_INTEGRATION_REQUEST'
export const CREATE_MAPPING_INTEGRATION_SUCCESS = 'CREATE_MAPPING_INTEGRATION_SUCCESS'
export const CREATE_MAPPING_INTEGRATION_FAIL = 'CREATE_MAPPING_INTEGRATION_FAIL'

export const LIST_SUMMARY_INTEGRATION_REQUEST = 'LIST_SUMMARY_INTEGRATION_REQUEST'
export const LIST_SUMMARY_INTEGRATION_SUCCESS = 'LIST_SUMMARY_INTEGRATION_SUCCESS'
export const LIST_SUMMARY_INTEGRATION_FAIL = 'LIST_SUMMARY_INTEGRATION_FAIL'

export const LIST_ITEMS_SUMMARY_REQUEST = 'LIST_ITEMS_SUMMARY_REQUEST'
export const LIST_ITEMS_SUMMARY_SUCCESS = 'LIST_ITEMS_SUMMARY_SUCCESS'
export const LIST_ITEMS_SUMMARY_FAIL = 'LIST_ITEMS_SUMMARY_FAIL'
